import { cn } from "@gymflow/helpers";
import { ToastContext } from "apps/portal/src/providers/ToastProvider/context";
import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";

import { CheckIcon, CopyIcon } from "../icons";
import { ReactiveButton } from "../ReactiveButton";
import Label from "./Label";

type CopyInputProps = {
  copyInfo: string;
  className?: string;
  label?: string;
};

export const CopyInput = ({ copyInfo, className, label }: CopyInputProps) => {
  const { t } = useTranslation();
  const { toast } = useContext(ToastContext);

  const onCopy = useCallback(() => {
    navigator.clipboard.writeText(copyInfo);

    toast({
      message: t("portal.common.copied"),
      type: "small",
    });
  }, [copyInfo, t, toast]);

  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <Label label={label} />
      <div className="flex h-12 flex-row items-center justify-between rounded-xl bg-gray-100 pl-3 pr-1">
        <div className="line-clamp-1 text-base font-medium text-gray-950">
          {copyInfo}
        </div>
        <ReactiveButton
          size="small"
          className="aspect-square p-0"
          onClick={() => onCopy()}
          reactiveContent={<CheckIcon pathClassName="stroke-gray-950" />}
        >
          <CopyIcon className="size-5" pathClassName="stroke-gray-950" />
        </ReactiveButton>
      </div>
    </div>
  );
};
